const {__} = window.wp.i18n;

function slimSelectDeselectAll(info) {
  const curData = this.data.data;
  const selectedCount = info.length;
  const hasDeselectButton = curData.filter(v => v.value === '' || v.value === 'Deselect all').length > 0;
  const wantsDeselect = this.selected().includes('Deselect all') || this.selected().includes('');

  if (wantsDeselect) {
    this.set([]);
    this.setData(curData.filter(v => v.value !== '' && v.value !== 'Deselect all'));
    return;
  }

  if (selectedCount && !hasDeselectButton) {
    curData.unshift({
      value: '',
      text: 'Deselect all '
    });
    this.setData(curData);
  }
}

export default function slimSelectInit() {
  new SlimSelect({
    select: '#filter-country',
    placeholder: __('Countries', 'ae'),
    closeOnSelect: false,
    showSearch: false,
    hideSelectedOption: true,
    onChange: slimSelectDeselectAll
  });
  new SlimSelect({
    select: '#filter-animal',
    placeholder: __('Animals', 'ae'),
    closeOnSelect: false,
    showSearch: false,
    hideSelectedOption: true,
    onChange: slimSelectDeselectAll
  });
  new SlimSelect({
    select: '#filter-issue-tax',
    placeholder: __('Issues', 'ae'),
    closeOnSelect: false,
    showSearch: false,
    hideSelectedOption: true,
    onChange: slimSelectDeselectAll
  });
  new SlimSelect({
    select: '#filter-ae-year',
    placeholder: __('Years', 'ae'),
    closeOnSelect: false,
    showSearch: false,
    hideSelectedOption: true,
    onChange: slimSelectDeselectAll
  });
};
